import { render, staticRenderFns } from "./ViewSingleQuote.vue?vue&type=template&id=769847d5"
import script from "./ViewSingleQuote.vue?vue&type=script&lang=ts"
export * from "./ViewSingleQuote.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports